
import React from "react";
import '../styles/CampaignInfoScreen.css';

// @ts-check

/**
 *  @typedef {import('./coreTypes').JSX} JSX
 */


/**
 * 
 * @param {{title: string, info: string, image: string, mirrored: ?boolean, narrow: ?boolean }} props 
 * @returns {JSX}
 */
function CampaignInfoScreen(props) {
    
  const titleP = (<p className="campaign-info__title__text">{props.title}</p>);

  if (props.mirrored) {

    return (
        <div className="campaign-info__container">
            <div className="campaign-info__container__right">
                <img className="campaign-info__image" src={props.image} alt={props.title}/>
            </div>
            <div className="campaign-info__container__left">
                { (props.narrow)
                   ? <div className="campaign-info__title__view--narrow">{titleP}</div>
                   : <div className="campaign-info__title__view">{titleP}</div>}
                <p className="campaign-info__info">{props.info}</p>
            </div>
        </div>);
  }
  else {
    return (
        <div className="campaign-info__container">
            <div className="campaign-info__container__left">
            { (props.narrow)
                   ? <div className="campaign-info__title__view--narrow">{titleP}</div>
                   : <div className="campaign-info__title__view">{titleP}</div>}
                <p className="campaign-info__info">{props.info}</p>
            </div>
            <div className="campaign-info__container__right">
                <img className="campaign-info__image" src={props.image} alt={props.title}/>
            </div>
        </div>);
  }
}

export default CampaignInfoScreen;